import Banners from "./Banners";
import Brands from "./Brands";
import TopCategories from "./TopCategories";
import NewsBlock from "./NewsBlock";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getTopCategories} from "../../api/catalog";
import {useContext, useEffect} from "react";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {getIndex} from "../../api/utils";
import ProductSlider from "../catalog/ProductSlider";

export default function Index() {
    const [_, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data: topCategories, status} = useQuery({
        queryKey: ['top-categories'],
        queryFn: () => getTopCategories(),
        placeholderData: keepPreviousData
    })

    const {data: indexData, status: indexStatus} = useQuery({
        queryKey: ['index', 'data'],
        queryFn: () => getIndex()
    })

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'})
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                return;
        }
    }, [status]);

    const newProducts = indexData?.products && indexData?.products?.find(section => section.id == 'new') ;

    return (<main className="page">
        <div data-observ></div>
        <div className="about">
            <div className="container">
                <Banners/>

                <TopCategories categories={topCategories?.categories} />

                <div className="d-flex flex-column about__prod-cat-row prod-cat__row">
                    {newProducts && <ProductSlider products={newProducts.products.filter(p => p.has_stock).slice(0, 12)}  header={'Новинки'} />}
                </div>
            </div>
        </div>
        <Brands />
        {indexData?.latestNews && <NewsBlock news={indexData.latestNews} />}
        {/*<PartnerSolutions />*/}
        {/*<Decisions />*/}
        {/*<Connect />*/}


    </main>)
}